<template>
  <Announcement
    v-bind="$props"
    :shouldShowForAdmin="shouldShowForAdmin"
    @main-action="emitMainAction"
  >
    <slot />
  </Announcement>
</template>

<script>
import Announcement from 'client/components/Announcement/Announcement.vue';
import AnnouncementBannerDisplayMixin from 'client/GrowthEngineering/utilities/AnnouncementBannerDisplayMixin';
import AnnouncementMixin from 'client/components/Announcement/AnnouncementMixin';

export default {
  // Use AnnouncementWrapper in place of directly using Announcement
  // We don't want to show brand new admins announcements (1 day old orgs)
  name: 'AnnouncementWrapper',

  components: {
    Announcement,
  },
  // Store must not live on Announcement, thus the AnnouncementWrapper
  mixins: [AnnouncementBannerDisplayMixin, AnnouncementMixin],

  methods: {
    emitMainAction() {
      this.$emit('main-action');
    },
  },
};
</script>
